module.exports = __webpack_public_path__ + "media/images/new/roadpass_pro_phone@2x-3f264f090e3dc242a08bc2c3ef13106b.png";